import {Component, OnInit} from '@angular/core';
import {IntelligenceService} from '../../../services/intelligence.service';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-e-waste-legislation',
  templateUrl: './e-waste-legislation.component.html',
  styleUrls: ['./e-waste-legislation.component.scss']
})
export class EWasteLegislationComponent implements OnInit {

  text = 'Categories in scope of E-Waste Legislation';
  subtitle = '';
  years!: number[];
  data!: IntelligenceData[];
  categories!: string[];
  categoryFilters?: string[];

  constructor(private readonly intelligenceService: IntelligenceService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.intelligenceService.getEWasteCategories().subscribe(data => {
      const answerFormat = JSON.parse(JSON.stringify(data));
      this.categories = answerFormat.AvailableAnswers.filter((category: string) => category != '');
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.intelligenceService.getYears().subscribe(data => {
        this.years = data;
        if (data.length > 0) {
          if (!search.year) {
            search.year = data[0];
          }
          this.intelligenceService.getEWasteLegislation(search).subscribe(response => {
            this.data = response;
            this.categoryFilters = search.eWasteCategories;
            // this.subtitle = search.year.toString();
          });
        }
      });
    });
  }

  searchData(event: IntelligenceSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
